import { useSelector } from 'react-redux';
import { Box, Button, MapButton, Link } from '@methanesat/ui-components';
import { formatDateForUrl } from '../../../../utils';
import { useTranslate } from '../../../../hooks';
import { SLOW_selectEmissionsMapViewState } from '../../../../reducers';

export interface LinkToMainProps {
    targetId: string | undefined;
    startDateTime: string | undefined;
    floating?: boolean;
}

export const LinkToMain = ({ targetId, startDateTime, floating }: LinkToMainProps) => {
    const t = useTranslate();

    // viewState
    const viewState = useSelector(SLOW_selectEmissionsMapViewState);
    const { latitude, longitude, zoom } = viewState;

    const buildLink = () => {
        let link = '/en/emissions-map?platform=MethaneSAT&product=l4&color-scale=msat_warm_default';
        link += `&view-latitude=${latitude}`;
        link += `&view-longitude=${longitude}`;
        link += `&view-zoom=${zoom}`;
        link += `&target-${targetId}-date=${formatDateForUrl(new Date(startDateTime as string))}`;
        return link;
    };

    const mainLink = buildLink();
    const linkLabel = t(`emissionsMapPage.drawerWithCards.linkToMainPage`);

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
            {floating ? (
                <Link href={mainLink} target="_blank" data-testid="link-to-main-page-link">
                    <MapButton
                        data-testid="floating-link-to-main-page-button"
                        size="small"
                        sx={{
                            px: 2,
                            textTransform: 'uppercase',
                            fontWeight: 'bold',
                            marginLeft: 'auto',
                            marginRight: 'auto'
                        }}
                    >
                        {linkLabel}
                    </MapButton>
                </Link>
            ) : (
                <Button
                    variant="outlined"
                    data-testid="drawer-link-to-main-page-button"
                    sx={{ width: 'fit-content', marginLeft: 'auto', marginRight: 'auto', marginTop: 2 }}
                    href={mainLink}
                    target={'_blank'}
                >
                    {linkLabel}
                </Button>
            )}
        </Box>
    );
};
